<template>
  <active-button
    class="event-button"
    line-color="blue"
    line-position="left"
    :active="parseInt($route.params.event) === event.id"
    @click="$emit('click')"
  >
    <div class="event-info">
      <div class="event-kind" v-if="event.kind">{{ event.kind }}</div>
      <div>
        <div class="team">{{ event.home }}</div>
        <div class="turn" v-if="event.results.turn && event.results.turn === 1">
          <sport-icon small :name="sport" />
        </div>
        <div class="point" v-if="event.results.points">{{ event.results.points.home }}</div>
        <div class="score" v-if="event.results.score">{{ event.results.score.home }}</div>
      </div>
      <div v-if="event.away">
        <div class="team">{{ event.away }}</div>
        <div class="turn" v-if="event.results.turn && event.results.turn === 2">
          <sport-icon small :name="sport" />
        </div>
        <div class="point" v-if="event.results.points">{{ event.results.points.away }}</div>
        <div class="score" v-if="event.results.score">{{ event.results.score.away }}</div>
      </div>
    </div>
    <div class="comment">
      <div class="number blue-color" v-if="event.number">{{ event.number }}</div>
      <div class="time">
        {{ event.results.minute ? event.results.minute : '' }}
        <span class="time-blink" v-if="event.results.minute">'</span>
        {{ event.results.comment }}
      </div>
    </div>
  </active-button>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import SportIcon from '@/components/icons/SportIcon'

export default {
  components: {
    ActiveButton,
    SportIcon
  },
  props: {
    event: Object,
    sport: String
  }
}
</script>

<style scoped>
.event-button { cursor: pointer; display: flex; flex-direction: column; font-size: 12px; margin-left: 8px; padding: 5px 3px 5px 8px; position: relative; -webkit-transition: background .3s; -moz-transition: background .3s; -o-transition: background .3s; transition: background .3s; }
.event-button:hover { background: rgba(255, 255, 255, .05); }
.event-button:before { background: #8c9eff; border-radius: 1px; bottom: 0; content: ''; height: 100%; left: 0; position: absolute; top: 0; transform: scaleY(0); transition: transform .3s; width: 2px; }
.event-button.active:before { transform: scaleY(1); }
.event-info > div { display: flex; }
.event-kind { color: #c71585; }
.team { flex: 1; margin-right: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.turn { margin-top: -1px; }
.point { color: #ffa726; text-align: center; width: 20px; }
.score { color: #ffd54f; text-align: center; width: 24px; }
.comment { display: flex; padding-right: 5px; width: 100%; }
.number { margin-right: 8px; }
.time { color: #aaa; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
</style>



// WEBPACK FOOTER //
// src/components/results/live/menu/Event.vue